import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-grid p-m-0 kn-flex" }
const _hoisted_2 = { class: "p-col-4 p-sm-4 p-md-3 p-p-0 p-d-flex p-flex-column kn-flex" }
const _hoisted_3 = {
  id: "drivers-list-container",
  class: "kn-flex kn-relative"
}
const _hoisted_4 = {
  id: "driver-details-container",
  class: "p-m-2 kn-flex kn-relative"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "p-fluid p-formgrid p-grid p-m-2" }
const _hoisted_7 = { class: "p-field p-col-12 p-mt-2" }
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = {
  for: "title",
  class: "kn-material-input-label"
}
const _hoisted_10 = { class: "p-field p-col-12" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_13 = {
  key: 0,
  class: "p-field p-col-12"
}
const _hoisted_14 = { class: "p-float-label" }
const _hoisted_15 = {
  for: "dateFormat",
  class: "kn-material-input-label"
}
const _hoisted_16 = {
  key: 1,
  class: "p-field p-col-12"
}
const _hoisted_17 = { class: "p-float-label" }
const _hoisted_18 = {
  for: "title",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_KnListBox = _resolveComponent("KnListBox")
  const _component_InlineMessage = _resolveComponent("InlineMessage")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.outputParams.title')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_Button, {
            label: _ctx.$t('common.add'),
            class: "p-button-text p-button-rounded p-button-plain kn-white-color",
            onClick: _ctx.addParam
          }, null, 8, ["label", "onClick"])
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          style: _ctx.mainDescriptor.style.absoluteScroll
        }, [
          _createVNode(_component_KnListBox, {
            class: "kn-height-full",
            options: _ctx.document.outputParameters,
            settings: _ctx.outputParamDescriptor.knListSettings,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectParam($event.item))),
            onDelete: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.deleteParamConfirm($event)), ["stop"]))
          }, null, 8, ["options", "settings"])
        ], 4)
      ])
    ]),
    _createVNode("div", {
      class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0",
      style: _ctx.mainDescriptor.style.driverDetailsContainer
    }, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.outputParams.paramDetails')), 1)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_4, [
        (Object.keys(_ctx.selectedParam).length === 0)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_InlineMessage, {
                severity: "info",
                class: "kn-width-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.outputParams.noParamSelected')), 1)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createBlock(_component_Card, { key: 1 }, {
              content: _withCtx(() => [
                _createVNode("form", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("span", _hoisted_8, [
                      _createVNode(_component_InputText, {
                        id: "title",
                        class: ["kn-material-input", {
                                            'p-invalid': _ctx.v$.selectedParam.name.$invalid && _ctx.v$.selectedParam.name.$dirty
                                        }],
                        disabled: _ctx.selectedParam.isUserDefined === null,
                        modelValue: _ctx.v$.selectedParam.name.$model,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.selectedParam.name.$model = $event)),
                        modelModifiers: { trim: true },
                        onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.selectedParam.name.$touch())),
                        onInput: _ctx.markSelectedParamForChange
                      }, null, 8, ["disabled", "modelValue", "class", "onInput"]),
                      _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('documentExecution.documentDetails.outputParams.paramName')) + " *", 1)
                    ]),
                    _createVNode(_component_KnValidationMessages, {
                      class: "p-mt-1",
                      vComp: _ctx.v$.selectedParam.name,
                      additionalTranslateParams: { fieldName: _ctx.$t('documentExecution.documentDetails.outputParams.paramName') }
                    }, null, 8, ["vComp", "additionalTranslateParams"])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("span", _hoisted_11, [
                      _createVNode(_component_Dropdown, {
                        id: "type",
                        class: "kn-material-input",
                        modelValue: _ctx.selectedParam.type,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedParam.type = $event)),
                        options: _ctx.typeList,
                        optionLabel: "valueCd",
                        disabled: _ctx.selectedParam.isUserDefined === null,
                        onChange: _ctx.markSelectedParamForChange
                      }, null, 8, ["modelValue", "options", "disabled", "onChange"]),
                      _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('documentExecution.documentDetails.outputParams.paramType')), 1)
                    ])
                  ]),
                  (_ctx.selectedParam.type.valueCd === 'DATE')
                    ? (_openBlock(), _createBlock("div", _hoisted_13, [
                        _createVNode("span", _hoisted_14, [
                          _createVNode(_component_Dropdown, {
                            id: "dateFormat",
                            class: "kn-material-input",
                            modelValue: _ctx.selectedParam.formatCode,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedParam.formatCode = $event)),
                            options: _ctx.dateFormats,
                            optionLabel: "translatedValueName",
                            optionValue: "valueCd",
                            disabled: _ctx.selectedParam.isUserDefined === null,
                            onChange: _ctx.markSelectedParamForChange
                          }, null, 8, ["modelValue", "options", "disabled", "onChange"]),
                          _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanDateFormat')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedParam.type.valueCd === 'DATE' && _ctx.selectedParam.formatCode === 'CUSTOM')
                    ? (_openBlock(), _createBlock("div", _hoisted_16, [
                        _createVNode("span", _hoisted_17, [
                          _createVNode(_component_InputText, {
                            id: "title",
                            class: "kn-material-input",
                            modelValue: _ctx.selectedParam.formatValue,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedParam.formatValue = $event)),
                            disabled: _ctx.selectedParam.isUserDefined === null,
                            onInput: _ctx.markSelectedParamForChange
                          }, null, 8, ["modelValue", "disabled", "onInput"]),
                          _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('documentExecution.documentDetails.outputParams.customValue')) + " *", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
      ])
    ], 4)
  ]))
}